import Vue from 'vue';
import Vuex from 'vuex';

import account from './account';
import tree from './tree';
import point from './point';
import admin from './admin';
import alarm from './alarm';
import route from './route';
import gateway from './gateway';
import device from './device';
import trigger from './trigger';
import trend from './trend';
import measurement from './measurement';
import deviceConfigurations from './deviceConfigurations';
import frequencyPeakAlarm from './frequencyPeakAlarm';
import measurementsDetails from './measurementsDetails';
import vibrationAnalyzeReport from './vibrationAnalyzeReport';
import duck from './duck';
import sensor from './sensor';
import dashboard from './dashboard';
import compareSpectrum from './compareSpectrum';
import dashboardDate from './dashboardDate'

import VuexPersistence from 'vuex-persist';
import localForage from 'localforage';
const vuexLocal = new VuexPersistence({
    modules: ['compareSpectrum'],
    storage: localForage,
    asyncStorage: true,
});
Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        account,
        tree,
        admin,
        route,
        alarm,
        point,
        gateway,
        trigger,
        device,
        trend,
        measurement,
        deviceConfigurations,
        measurementsDetails,
        dashboard,
        frequencyPeakAlarm,
        vibrationAnalyzeReport,
        duck,
        sensor,
        compareSpectrum,
        dashboardDate
    },
    plugins: [vuexLocal.plugin]
});
